import { Location, Matrix } from "./types";

function setLocation<T>(matrix: Matrix<T>, location: Location, value: T) {
  matrix[location.row][location.col] = value;
}

export default setLocation;
